<app-sheet [open]="open" [deskW]="460" maxH="86%" (close)="close()">
  <div style="padding:8px 22px 28px" *ngIf="brand as brand">
    <img [src]="brand.logo" alt="logo" onerror="this.style.visibility='hidden'"
      style="width:78px;height:78px;border-radius:18px;object-fit:contain;margin-bottom:18px;box-shadow:var(--fr-shadow)">

    <!-- PHONE -->
    <ng-container *ngIf="step === 'phone'">
      <h2 class="bb-login-h">{{ 'Sign in to continue' | t }}</h2>
      <p class="bb-login-p">{{ (reason || 'We’ll text you a code to verify your number. Your cart is saved.') | t }}</p>
      <label class="bb-login-lbl">{{ 'Mobile number' | t }}</label>
      <div class="fr-ltr" style="display:flex;align-items:center;height:54px;border-radius:14px;border:1.5px solid var(--fr-border-2);overflow:hidden;background:var(--fr-surface)">
        <span style="display:flex;align-items:center;gap:6px;padding:0 13px;height:100%;border-inline-end:1.5px solid var(--fr-border-2);font-weight:700;font-size:15px;color:var(--fr-text)">
          <span style="font-size:18px;margin-bottom: 5px;">🇪🇬</span> +20
        </span>
        <input #phoneInput [ngModel]="phone" (ngModelChange)="onPhoneInput($event, phoneInput)"
          inputmode="numeric" maxlength="10" placeholder="10 1234 5678" name="phone"
          style="flex:1;border:none;outline:none;height:100%;padding:0 14px;font-size:16px;font-family:var(--fr-font);letter-spacing:0.04em;background:transparent;color:var(--fr-text)">
      </div>
      <div *ngIf="error" class="bb-login-err">{{ error | t }}</div>
      <div style="margin-top:22px">
        <app-btn [full]="true" size="lg" [disabled]="!phoneComplete || busy" iconEnd="solar:arrow-right-linear" (act)="continueFromPhone()">
          <app-spinner *ngIf="busy" [size]="18" color="#fff"></app-spinner>
          {{ 'Continue' | t }}
        </app-btn>
      </div>
      <p style="margin:16px 4px 0;font-size:11.5px;color:var(--fr-text-3);line-height:1.5;text-align:center">By continuing you agree to {{ brand.name }}’s Terms &amp; Privacy Policy.</p>
      <div style="display:flex;align-items:center;gap:8px;margin-top:18px;justify-content:center;color:var(--fr-text-3);font-size:12px">
        <app-icon name="solar:lock-keyhole-minimalistic-bold" [size]="14"></app-icon> Secured by Sonic · OTP verification
      </div>
    </ng-container>

    <!-- OTP -->
    <ng-container *ngIf="step === 'otp'">
      <h2 class="bb-login-h">{{ 'Enter your code' | t }}</h2>
      <p class="bb-login-p">{{ 'Sent to' | t }} <b class="fr-num fr-ltr" style="display:inline-block">+20 {{ phone }}</b> · <button (click)="step = 'phone'" class="bb-login-link">{{ 'Edit' | t }}</button></p>

      <label class="bb-login-lbl">{{ 'Verification code' | t }}</label>
      <input class="bb-keep-size" [ngModel]="otp" (ngModelChange)="onOtpInput($event)" (keydown.enter)="verifyOtp()" name="otp"
        inputmode="numeric" maxlength="6" placeholder="••••••" autofocus
        [style.border]="'1.5px solid ' + (error ? 'var(--fr-danger)' : 'var(--fr-border-2)')"
        style="width:100%;box-sizing:border-box;height:58px;border-radius:14px;outline:none;text-align:center;
               font-size:26px;font-weight:750;letter-spacing:0.5em;padding:0 8px;font-family:var(--fr-font);
               color:var(--fr-text);background:var(--fr-surface)">

      <div *ngIf="demoOtp" style="text-align:center;margin-top:8px;font-size:12.5px;color:var(--fr-text-3)">
        <!-- Test code: <button (click)="fillDemoOtp()" class="bb-login-link" style="font-size:12.5px" [disabled]="busy">{{ demoOtp }}</button> -->
      </div>
      <div *ngIf="error" class="bb-login-err" style="text-align:center">{{ error | t }}</div>

      <div style="margin-top:18px">
        <app-btn [full]="true" size="lg" [disabled]="otp.length < 6 || busy" icon="solar:check-circle-bold" (act)="verifyOtp()">
          <app-spinner *ngIf="busy" [size]="18" color="#fff"></app-spinner>
          {{ 'Confirm code' | t }}
        </app-btn>
      </div>

      <div style="text-align:center;margin-top:14px;font-size:13.5px;color:var(--fr-text-3)">
        <span *ngIf="timer > 0; else canResend" class="fr-num">Resend code in {{ timer }}s</span>
        <ng-template #canResend><button (click)="resend()" class="bb-login-link">{{ 'Resend code' | t }}</button></ng-template>
      </div>
    </ng-container>

    <!-- PASSWORD (returning user) -->
    <ng-container *ngIf="step === 'password'">
      <h2 class="bb-login-h">{{ 'Welcome back' | t }}</h2>
      <p class="bb-login-p">{{ 'Enter the password for' | t }} <b class="fr-num fr-ltr" style="display:inline-block">+20 {{ phone }}</b> · <button (click)="step = 'phone'" class="bb-login-link">{{ 'Edit' | t }}</button></p>
      <label class="bb-login-lbl">{{ 'Password' | t }}</label>
      <div [style.border]="'1.5px solid ' + (error ? 'var(--fr-danger)' : 'var(--fr-border-2)')" style="display:flex;align-items:center;height:54px;border-radius:14px;background:var(--fr-surface);overflow:hidden">
        <input [type]="showPw ? 'text' : 'password'" [(ngModel)]="loginPw" (ngModelChange)="error = ''" (keydown.enter)="loginPw && submitLogin()" [placeholder]="'Your password' | t" name="loginpw"
          style="flex:1;border:none;outline:none;height:100%;padding:0 16px;font-size:16px;font-family:var(--fr-font);background:transparent;color:var(--fr-text)">
        <button (click)="showPw = !showPw" style="border:none;background:none;cursor:pointer;padding:0 14px;color:var(--fr-text-3);display:flex">
          <app-icon [name]="showPw ? 'solar:eye-closed-linear' : 'solar:eye-linear'" [size]="19"></app-icon>
        </button>
      </div>
      <div *ngIf="error" class="bb-login-err">{{ error | t }}</div>
      <div style="text-align:end;margin-top:10px">
        <button (click)="goToOtp('forgot')" class="bb-login-link" style="font-size:13.5px">{{ 'Forgot password?' | t }}</button>
      </div>
      <div style="margin-top:18px">
        <app-btn [full]="true" size="lg" [disabled]="!loginPw || busy" icon="solar:lock-keyhole-bold" (act)="submitLogin()">
          <app-spinner *ngIf="busy" [size]="18" color="#fff"></app-spinner>
          {{ 'Sign in' | t }}
        </app-btn>
      </div>
    </ng-container>

    <!-- RESET / PROFILE password fields -->
    <ng-container *ngIf="step === 'reset' || step === 'profile'">
      <h2 class="bb-login-h">{{ (step === 'reset' ? 'Set a new password' : 'Complete your profile') | t }}</h2>
      <p class="bb-login-p">{{ (step === 'reset' ? 'Your number is verified. Choose a new password to sign in with.' : 'Your name for orders, and a password so you can sign in next time.') | t }}</p>

      <ng-container *ngIf="step === 'profile'">
        <label class="bb-login-lbl">{{ 'Your name' | t }}</label>
        <input [(ngModel)]="name" [placeholder]="'e.g. Nour Hassan' | t" name="name"
          [style.border]="'1.5px solid ' + (tried && !name.trim() ? 'var(--fr-danger)' : 'var(--fr-border-2)')"
          style="width:100%;box-sizing:border-box;height:54px;border-radius:14px;outline:none;padding:0 16px;font-size:16px;font-family:var(--fr-font);background:var(--fr-surface);color:var(--fr-text)">
        <div *ngIf="tried && !name.trim()" class="bb-login-err">{{ 'Name is required' | t }}</div>
        <label class="bb-login-lbl" style="margin-top:14px">{{ 'Password' | t }}</label>
      </ng-container>
      <label *ngIf="step === 'reset'" class="bb-login-lbl">{{ 'New password' | t }}</label>

      <div [style.border]="'1.5px solid ' + (tried && !pwOk ? 'var(--fr-danger)' : 'var(--fr-border-2)')" class="bb-pw-field">
        <input [type]="showPw ? 'text' : 'password'" [(ngModel)]="pw" [placeholder]="pwPlaceholder | t" name="pw"
          style="flex:1;border:none;outline:none;height:100%;padding:0 16px;font-size:16px;font-family:var(--fr-font);background:transparent;color:var(--fr-text)">
        <button (click)="showPw = !showPw" style="border:none;background:none;cursor:pointer;padding:0 14px;color:var(--fr-text-3);display:flex">
          <app-icon [name]="showPw ? 'solar:eye-closed-linear' : 'solar:eye-linear'" [size]="19"></app-icon>
        </button>
      </div>
      <div *ngIf="tried && !pwOk" class="bb-login-err">{{ pwError | t }}</div>

      <label class="bb-login-lbl" style="margin-top:14px">{{ 'Confirm password' | t }}</label>
      <div [style.border]="'1.5px solid ' + (tried && !pwMatch ? 'var(--fr-danger)' : 'var(--fr-border-2)')" class="bb-pw-field">
        <input [type]="showPw ? 'text' : 'password'" [(ngModel)]="pw2" [placeholder]="'Repeat the password' | t" name="pw2"
          style="flex:1;border:none;outline:none;height:100%;padding:0 16px;font-size:16px;font-family:var(--fr-font);background:transparent;color:var(--fr-text)">
      </div>
      <div *ngIf="tried && !pwMatch" class="bb-login-err">{{ 'Passwords don’t match' | t }}</div>
      <div *ngIf="error" class="bb-login-err">{{ error | t }}</div>

      <div style="margin-top:22px">
        <app-btn *ngIf="step === 'reset'" [full]="true" size="lg" [disabled]="busy" icon="solar:lock-keyhole-bold" (act)="submitReset()">
          <app-spinner *ngIf="busy" [size]="18" color="#fff"></app-spinner>
          {{ 'Save & sign in' | t }}
        </app-btn>
        <app-btn *ngIf="step === 'profile'" [full]="true" size="lg" [disabled]="busy" iconEnd="solar:arrow-right-linear" (act)="submitProfile()">
          <app-spinner *ngIf="busy" [size]="18" color="#fff"></app-spinner>
          {{ 'Continue' | t }}
        </app-btn>
      </div>
    </ng-container>

    <!-- LOCATION -->
    <ng-container *ngIf="step === 'location'">
      <h2 class="bb-login-h">{{ 'Allow your location' | t }}</h2>
      <p class="bb-login-p">We use your location to find the nearest branch, confirm you’re in a delivery zone, and give accurate delivery times.</p>

      <div *ngIf="locState === 'granted'; else notGranted" style="display:flex;align-items:center;gap:12px;background:color-mix(in srgb, var(--fr-success) 9%, var(--fr-surface));border:1px solid color-mix(in srgb, var(--fr-success) 30%, transparent);border-radius:14px;padding:14px 15px;margin-bottom:20px">
        <app-icon name="solar:map-point-wave-bold" [size]="24" color="var(--fr-success-strong)"></app-icon>
        <div style="flex:1">
          <div style="font-weight:750;font-size:14px;color:var(--fr-text)">{{ 'Location found' | t }}</div>
          <div *ngIf="brand.branches.length" style="font-size:12.5px;color:var(--fr-text-2)">{{ 'Nearest branch' | t }}: {{ brand.branches[0].name }} · <span class="fr-num">{{ brand.branches[0].eta }} min</span></div>
        </div>
        <app-icon name="solar:check-circle-bold" [size]="22" color="var(--fr-success)"></app-icon>
      </div>
      <ng-template #notGranted>
        <div style="display:flex;align-items:center;gap:12px;background:var(--fr-surface-3);border-radius:14px;padding:14px 15px;margin-bottom:20px">
          <app-icon name="solar:gps-bold" [size]="24" color="var(--brand)"></app-icon>
          <div *ngIf="locState !== 'denied'" style="flex:1;font-size:13px;line-height:1.5;color:var(--fr-text-2)">Location is <b style="color:var(--fr-text)">required</b> to order — it decides which branch prepares your food.</div>
          <div *ngIf="locState === 'denied'" style="flex:1;font-size:13px;line-height:1.5;color:var(--fr-text-2)">We couldn’t get your location. Allow access in your browser and try again, or continue for now.</div>
        </div>
      </ng-template>

      <app-btn *ngIf="locState === 'granted'" [full]="true" size="lg" iconEnd="solar:arrow-right-linear" (act)="finish()">{{ 'Start ordering' | t }}</app-btn>
      <app-btn *ngIf="locState === 'locating'" [full]="true" size="lg" [disabled]="true">
        <app-spinner [size]="20" color="#fff"></app-spinner> <span style="margin-inline-start:8px">{{ 'Locating…' | t }}</span>
      </app-btn>
      <app-btn *ngIf="locState === 'idle'" [full]="true" size="lg" icon="solar:gps-bold" (act)="allowLocation()">{{ 'Allow location access' | t }}</app-btn>
      <app-btn *ngIf="locState === 'denied'" [full]="true" size="lg" icon="solar:gps-bold" (act)="allowLocation()">{{ 'Try again' | t }}</app-btn>
      <button *ngIf="locState === 'denied'" (click)="finish()" style="width:100%;margin-top:10px;border:none;background:none;cursor:pointer;color:var(--fr-text-3);font-size:13.5px;font-weight:600;padding:8px">{{ 'Continue for now' | t }}</button>
    </ng-container>
  </div>
</app-sheet>
